import { createContext, useContext } from 'react';

export const MenuFiltersContext = createContext({});

export const useMenuFilters = () => useContext<any>(MenuFiltersContext);
